//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import { imagePlaceholderProduct } from '~/common';
import SfBanner from "~/themes/fiskarsMoominDefault/components/components/molecules/SfBanner/SfBanner.vue";
import {computed} from "@nuxtjs/composition-api";
import { checkIfUrlIsExternal } from "~/helpers/validation-utils";

export default Vue.extend({
  name: 'Banner',
  components: {
    SfBanner,
  },
  methods: {
    checkAndReturnLink(link) {
      if(!link) return "/";

      if(checkIfUrlIsExternal(link)) {
        return link;
      } else {
        return this.localePath(link);
      }
    }
  },
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    description: {
      type: [String, Object],
    },
    buttonText: {
      type: String,
    },
    link: {
      type: String,
    },
    buttonTextSecondary: {
      type: String,
    },
    linkSecondary: {
      type: String,
    },
    image: {
      type: Object,
      default: () => ({
        desktop: imagePlaceholderProduct,
        mobile: imagePlaceholderProduct,
        thumbnail: imagePlaceholderProduct,
        alt: "image",
      })
    },
    background: {
      type: Object,
      default: () => {
        return {value: ''}
      }
    },
    properties: {
      type: Object
    }
  },
  setup(props) {
    const returnDescription = computed(() => props.description?.value);
    const returnBackground = computed(() => props.background?.background?.selectionValues[0]?.key);

    return {
      returnDescription,
      returnBackground,
    }
  }
})
